module.exports = __webpack_public_path__ + "files/22e3972d9f6df7da06bed09b362205b0.png";